import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import Axios from "axios";
import NeoTypes from '../NeoTypes';
import AxiosUtils from "../../AxiosUtils";
var ConfigService = /** @class */ (function () {
    function ConfigService(config) {
        this.config = config;
    }
    ConfigService.prototype.loadConfig = function (path, store) {
        return __awaiter(this, void 0, void 0, function () {
            var configData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 7]);
                        return [4 /*yield*/, this.fetchConfig(path)];
                    case 1:
                        configData = (_a.sent()).data;
                        if (!store) return [3 /*break*/, 3];
                        return [4 /*yield*/, store.putAsync(configData, 1)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4:
                        e_1 = _a.sent();
                        if (!(store && AxiosUtils.isNetworkError(e_1) && !window.navigator.onLine)) return [3 /*break*/, 6];
                        return [4 /*yield*/, store.getAsync(1)];
                    case 5:
                        // get config from index db
                        configData = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!configData) {
                            throw new Error("ConfigService - Error loading configuration: ".concat(e_1));
                        }
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, this.setConfig(configData)];
                }
            });
        });
    };
    ConfigService.prototype.fetchConfig = function (path) {
        path = path !== null && path !== void 0 ? path : "".concat(this.config.baseUrl, "/config.json");
        // Fetch config with timestamp to prevent caching
        var timestamp = new Date().getTime();
        return Axios.get("".concat(path, "?").concat(timestamp));
    };
    ConfigService.prototype.setConfig = function (configData) {
        // The raw parsed json objects properties are copied into the config model.
        // It is up to the config model to transform its properties if required (in the initialise method). 
        Object.assign(this.config, configData);
        this.config.initialise();
        return this.config;
    };
    Object.defineProperty(ConfigService, "isDevelopment", {
        get: function () {
            return process.env.NODE_ENV === "development";
        },
        enumerable: false,
        configurable: true
    });
    ConfigService = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.Config.ConfigModel.symbol)),
        __metadata("design:paramtypes", [Object])
    ], ConfigService);
    return ConfigService;
}());
export { ConfigService };
